import { gql } from '@apollo/client'

export const AUTH_TWO_FACTOR_STATUS_QUERY = gql`
  query AUTH_TWO_FACTOR_STATUS_QUERY {
    authTwoFactorStatus {
      ok
      data {
        enabled
        enabledAt
      }
    }
  }
`
